export default function () {
  return {
    bateriiuzate: [],
    bateriiuzateCurrentPage: 1,
    bateriiuzateLastPage: 1,
    bateriiuzatePerPage: 0,
    bateriiuzateTotal: 0,
    indexPage: null,
    search: '',
    bateriiuzateLoading: false,
  }
}
